import { ThemeType } from "../type/type";
import { DEFAULT_THEME_COLOR, SYSTEM_CONFIGURATION_KEYS } from "../constants";
import type { SystemConfiguration } from "../services/common/type/common.type";

export const normalizeThemeType = (themeType?: string | null): ThemeType => {
  return themeType?.toLowerCase() === "dark" ? "dark" : "light";
};

export const applyThemeClass = (themeType?: string | null): void => {
  if (typeof document === "undefined") {
    return;
  }

  const normalizedTheme = normalizeThemeType(themeType);
  document.documentElement.classList.toggle("dark", normalizedTheme === "dark");
};

export const resolveThemeColor = (color?: string | null): string => {
  const trimmed = color?.trim();
  return trimmed ? trimmed : DEFAULT_THEME_COLOR;
};

export const resolveActiveThemeColor = (
  userThemeColor?: string | null,
  systemThemeColor?: string | null,
): string => {
  const trimmedUserThemeColor = userThemeColor?.trim();

  if (trimmedUserThemeColor) {
    return trimmedUserThemeColor;
  }

  return resolveThemeColor(systemThemeColor);
};

export const getSystemThemeColor = (
  configurations?: SystemConfiguration[] | null,
): string | undefined => {
  const profileConfiguration = configurations?.find(
    (config) =>
      config.configuration_name ===
      SYSTEM_CONFIGURATION_KEYS.systemProfileConfiguration,
  );

  if (!profileConfiguration?.configuration_value) {
    return undefined;
  }

  try {
    const parsedProfileConfiguration = JSON.parse(
      profileConfiguration.configuration_value,
    ) as { themeColor?: string };

    return parsedProfileConfiguration.themeColor;
  } catch {
    return undefined;
  }
};

export const applyThemeColor = (color?: string | null): void => {
  if (typeof document === "undefined") {
    return;
  }

  const resolvedThemeColor = resolveThemeColor(color);

  document.documentElement.style.setProperty(
    "--default-theme-color",
    resolvedThemeColor,
  );
  document.documentElement.style.removeProperty("--primary");
  document.documentElement.style.removeProperty("--hover-active");
  document.documentElement.style.removeProperty("--color-hover-active");
};
